import EventTarget from "./eventTaget";

export default class AppManager extends EventTarget {
    constructor() {
        super();
        this.add = this.add.bind(this);
        this.remove = this.remove.bind(this);
        this.update = this.update.bind(this);
    }
    add({
        id, el, appType, options = {}, context = {}, namespace
    }) {
        this.dispatchEvent({
            appType,
            context,
            el,
            id,
            options,
            namespace,
            type: "ADD"
        });
    }
    remove({ id, namespace }) {
        this.dispatchEvent({
            id, namespace, type: "REMOVE",
        });
    }
    update({
        id, el, appType, options = {}, context = {}, namespace
    }) {
        this.dispatchEvent({
            appType,
            context,
            el,
            id,
            options,
            namespace,
            type: "UPDATE"
        });
    }
}
